import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M3.983 4.812S1.966 19 3.983 20s14.53 0 14.53 0"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M20.127 7.787c-2.627-1.287-4.505 4.368-5.444 4.986-.938.58-1.502-1.74-2.59-2.164-2.704-1.005-5.22 5.294-5.22 5.294"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
  </svg>
);
export const StatisticIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
